import { Link, Stack } from 'expo-router';
import Item from '@/components/UI/PressableRow';
import Text from '@/components/UI/Text';
import Icon from '@/components/Unistyles/Icon';

export default function ProfileAccount() {
  return (
    <>
      <Stack.Screen
        options={{
          title: 'Account',
        }}
      />
      <Link href="/profile/account/delete" asChild>
        <Item>
          <Icon name="person-remove-outline" />
          <Text bold>Request Account Deletion</Text>
        </Item>
      </Link>
    </>
  );
}
